import React, {useEffect} from 'react';
import {ActionModal, ErrorModal, FormInput, useErrorHandler} from '../../../../shared';
import {useEditRegionForm} from '../../model';

interface EditRegionModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  regionId: string | null;
}

export const EditRegionModal = ({open, setOpen, regionId}: EditRegionModalProps) => {
  const {values, errors, touched, handleChange, handleBlur, isLoading, submitError, resetForm, submitForm} =
    useEditRegionForm({setOpen, regionId});

  const {isErrorModalOpen, errorInfo, handleError, handleClose} = useErrorHandler({
    resourceName: 'Регион',
    title: 'Ошибка при редактировании региона',
  });

  useEffect(() => {
    if (submitError) {
      handleError(submitError);
    }
  }, [submitError, handleError]);

  return (
    <>
      <ActionModal
        open={open}
        onClose={() => setOpen(false)}
        setOpen={() => setOpen(false)}
        resetForm={resetForm}
        submitForm={submitForm}
        isLoading={isLoading}
        size={'m'}
        buttonsSize={'l'}
        caption={'Редактировать регион'}
        textButtonApply={'Сохранить'}
        textButtonCancel={'Отменить'}>
        <FormInput
          label="Название"
          placeholder="Название региона"
          name="name"
          value={values.name}
          onChange={handleChange}
          onBlur={handleBlur}
          error={touched.name && errors.name}
        />
        <FormInput
          label="Порядок отображения"
          placeholder="Порядок отображения"
          name="order"
          value={values.order.toString()}
          onChange={handleChange}
          onBlur={handleBlur}
          error={touched.order && errors.order}
        />
      </ActionModal>
      <ErrorModal open={isErrorModalOpen} onClose={handleClose} title={errorInfo.title} message={errorInfo.message} />
    </>
  );
};
